export const SERVICES_MUNICIPAUX_PAGE = {
  title: "Services municipaux",
  eyebrow: "Votre mairie",
  description:
    "Retrouvez rapidement les services de la Ville, leurs coordonnées, horaires, adresses et informations pratiques.",
  heroImageUrl:
    "https://cdn-s-www.leprogres.fr/images/1285AA4C-87A4-4781-B29B-F89D0A2C8FAA/MF_contenu/genas-l-accueil-du-public-en-mairie-se-fera-avec-des-horaires-modifies-1631287297.jpg",
  crumbs: [
    { label: "Accueil", href: "/" },
    { label: "Ma Mairie" },
    { label: "Services municipaux" },
  ],
};

export const SERVICE_SORT_OPTIONS = [
  { value: "nom", label: "Nom du service" },
  { value: "categorie", label: "Famille de services" },
  { value: "type", label: "Type de service" },
];